import { render, staticRenderFns } from "./TaskTreeCommentChild.vue?vue&type=template&id=61662dca&scoped=true&"
import script from "./TaskTreeCommentChild.vue?vue&type=script&lang=js&"
export * from "./TaskTreeCommentChild.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61662dca",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/tgs-automation/tgs-automation/mojaweb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('61662dca')) {
      api.createRecord('61662dca', component.options)
    } else {
      api.reload('61662dca', component.options)
    }
    module.hot.accept("./TaskTreeCommentChild.vue?vue&type=template&id=61662dca&scoped=true&", function () {
      api.rerender('61662dca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Task/TaskTreeCommentChild.vue"
export default component.exports